import React from 'react';
import '../styles/pages/Services.scss';
import calendrier from '../assets/servicesIcons/calendrier-blue.png';
import comptable from '../assets/servicesIcons/comptable-blue.png';
import fichier from '../assets/servicesIcons/fichier-blue.png';
import recrutement from '../assets/servicesIcons/recrutement-blue.png';
import secretaire from '../assets/servicesIcons/secretaire.png';
import system from '../assets/servicesIcons/system-blue.png';
import traduction from '../assets/servicesIcons/traduction-blue.png';
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();
  const services = [
    {
      title: t('services.items.remote_secretary.title'),
      desc: t('services.items.remote_secretary.desc'),
      icon: <img src={secretaire} alt={t('services.items.remote_secretary.alt')} style={{ width: 48, height: 48, objectFit: 'contain' }} />,
      active: true,
    },
    {
      title: t('services.items.admin_assist.title'),
      desc: t('services.items.admin_assist.desc'),
      icon: <img src={system} alt={t('services.items.admin_assist.alt')} style={{ width: 48, height: 48, objectFit: 'contain' }} />,
    },
    {
      title: t('services.items.translation.title'),
      desc: t('services.items.translation.desc'),
      icon: <img src={traduction} alt={t('services.items.translation.alt')} style={{ width: 48, height: 48, objectFit: 'contain' }} />,
    },
    {
      title: t('services.items.recruitment.title'),
      desc: t('services.items.recruitment.desc'),
      icon: <img src={recrutement} alt={t('services.items.recruitment.alt')} style={{ width: 48, height: 48, objectFit: 'contain' }} />,
    },
    {
      title: t('services.items.accounting.title'),
      desc: t('services.items.accounting.desc'),
      icon: <img src={comptable} alt={t('services.items.accounting.alt')} style={{ width: 48, height: 48, objectFit: 'contain' }} />,
    },
    {
      title: t('services.items.agenda.title'),
      desc: t('services.items.agenda.desc'),
      icon: <img src={calendrier} alt={t('services.items.agenda.alt')} style={{ width: 48, height: 48, objectFit: 'contain' }} />,
    },
    {
      title: t('services.items.claims.title'),
      desc: t('services.items.claims.desc'),
      icon: <img src={fichier} alt={t('services.items.claims.alt')} style={{ width: 48, height: 48, objectFit: 'contain' }} />,
    },
  ];

  return (
    <div className="services-page">
      <h1>{t('services.title')}</h1>
      <p className="services-subtitle">
        {t('services.subtitle')}
      </p>
      <hr className="services-divider" />
      <div className="services-grid">
        <div className="services-row">
          {services.slice(0, 4).map((service, idx) => (
            <div className={`service-card${service.active ? ' active' : ''}`} key={idx}>
              <div className="service-icon">{service.icon}</div>
              <div className="service-title">{service.title}</div>
              <div className="service-desc">{service.desc}</div>
            </div>
          ))}
        </div>
        <div className="services-row">
          {services.slice(4, 7).map((service, idx) => (
            <div className={`service-card${service.active ? ' active' : ''}`} key={idx + 4}>
              <div className="service-icon">{service.icon}</div>
              <div className="service-title">{service.title}</div>
              <div className="service-desc">{service.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;